import React, { useMemo } from 'react';
import { connectHits } from 'react-instantsearch-dom';
import { PropTypes } from 'prop-types';
import { useQuery } from '@apollo/client';

const PropertyContactsListHits = props => {
    const {
        hits,
        hitComponent,
        listClasses,
        listItemClasses,
        query,
        isLoggedIn,
        transformFunc,
        typePlural,
        showMailIcon,
        showTrashIcon,
        onTrashClick,
    } = props;
    const { loading, data } = useQuery(query, { skip: !isLoggedIn });
    const Hit = hitComponent;

    const favoriteIds = useMemo(() => {
        if (!data) return [];
        // graph service returning null for some saved items, probably only a staging issue
        const filtered = data?.[typePlural].filter(e => !!e);
        return filtered.map(c => c.recordId);
    }, [data, typePlural]);

    const getIsFavorite = hitObjectId => {
        if (loading) return false;
        const id = parseInt(hitObjectId.split('-')[1], 10);
        return favoriteIds.includes(id);
    };

    return (
        <>
            <div className={listClasses}>
                {hits.length === 0 && <p>No matches found</p>}
                {hits.map(hit => {
                    const isFavorite = getIsFavorite(hit.objectID);
                    return (
                        <div key={hit.objectID} className={listItemClasses}>
                            <Hit
                                {...transformFunc({ hit, isFavorite })}
                                showMailIcon={showMailIcon}
                                showTrashIcon={showTrashIcon}
                                onTrashClick={() => onTrashClick(hit)}
                            />
                        </div>
                    );
                })}
            </div>
        </>
    );
};

PropertyContactsListHits.propTypes = {
    hits: PropTypes.any,
    hitComponent: PropTypes.any,
    listClasses: PropTypes.string,
    listItemClasses: PropTypes.string,
    transformFunc: PropTypes.func,
    query: PropTypes.object,
    isLoggedIn: PropTypes.bool,
    typePlural: PropTypes.string,
    showMailIcon: PropTypes.bool,
    showTrashIcon: PropTypes.bool,
    onTrashClick: PropTypes.func,
};

export default connectHits(PropertyContactsListHits);
